import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { message } from 'antd'
import { picProcess } from '../../../utils/image'
import { cloneDeep } from 'lodash-es'
import classNames from 'classnames'
import request from '../../../utils/request'
import Button from '../../../baseComponent/button'
import Icon from '../../icon'
import Checkbox from '../../../baseComponent/checkbox'
import { MODES } from '../enum'
import './index.less'

export default forwardRef(
  (
    { onChange, colorId, blogId, platformId, skuImage, mainUrl, hasCurInstated, inspirationId, picUrl, sitePlatformId, ...props },
    ref
  ) => {
    const [mode, setMode] = useState(1)
    const [data, setData] = useState([])
    const [values, setValues] = useState([])

    const _onChange = (val) => {
      setValues(val)
      onChange?.(val)
    }
    useEffect(() => {
      fetchData()
    }, [])

    const fetchData = async () => {
      if (blogId && platformId && !isNaN(platformId)) {
        const params = {
          blogId,
          platformId,
          sitePlatformId,
          colorId,
        }
        if (hasCurInstated && inspirationId) {
          params.inspirationId = inspirationId
        }
        const result = await request
          .get('/zhikuan/inspiration/blog/get-blog-images', {
            params,
            ignoreError: true,
          })
          .catch((error) => {
            message.error(error.errorDesc)
          })
        setTimeout(() => {
          // 其他项目的message无法关闭 为了主动关闭
          message.destroy()
        }, 8000)
        if (result) {
          onChange?.(result)
          setValues(result)
          setData(result)
        }
      } else {
        const _url = skuImage || mainUrl || picUrl
        if (_url) {
          onChange?.([_url])
          setValues([_url])
          setData([_url])
        }
      }
    }

    useImperativeHandle(ref, () => {
      return {
        images: values,
      }
    })

    const renderDom = () => {
      if (data.length <= 1 || props.mode === MODES.PURCHASE) {
        return (
          <div className="mn-cover-wrap">
            <div className="mn-cover" style={{ background: `url(${skuImage || mainUrl || picUrl}) center/cover no-repeat` }}>
              {props.imageNum ? <div className="mn-collect-modal-big-img-wrap-cover-img-num">{props.imageNum} 个款式</div> : null}
            </div>
          </div>
        )
      }
      if (mode === 1) {
        return (
          <BigImg
            mode={mode}
            imageNum={props.imageNum}
            data={data}
            value={values}
            onChange={_onChange}
            onMode={() => setMode(2)}
          />
        )
      }
      return <TileImg mode={mode} value={values} onMode={() => setMode(1)} onChange={_onChange} data={data} />
    }
    return <div className="mn-collect-modal-img-wrap">{renderDom()}</div>
  }
)

const BigImg = ({ mode, onMode, value, onChange, data = [] }) => {
  const [selected, setSelected] = useState([])
  const [imgIndex, setImgIndex] = useState(0)
  const [imgLeft, setImgLeft] = useState(0)
  const imageWidth = 67
  const onSelect = (val) => {
    setImgIndex(val)
  }

  const _onChange = (item, val) => {
    const _index = selected.findIndex((i) => i === val)
    if (_index !== -1) {
      selected.splice(_index, 1)
    } else {
      selected.push(val)
    }
    onChange?.(selected)
  }

  useEffect(() => {
    setSelected(cloneDeep(value))
  }, [value])

  return (
    <div className="mn-collect-modal-mode-big-img">
      <div className="mn-collect-modal-big-img-wrap">
        {data.length ? <div className="mn-collect-modal-big-img-wrap-cover-img-num">{data.length} 个图片</div> : null}
        <img referrerPolicy="no-referrer" className="mn-collect-modal-big-img" src={picProcess(data[imgIndex])} />
      </div>
      <div className="mn-collect-modal-mode-big-img-switch">
        <div
          style={{ marginRight: '2px' }}
          className={classNames('mn-collect-modal-mode-big-img-switch-btn', { disabled: !(imgLeft <= -imageWidth) })}
          onClick={() => {
            if (imgLeft <= -imageWidth) {
              setImgLeft((pre) => pre + imageWidth)
            }
          }}
        >
          <Icon type="m-Vxing_zuo" />
        </div>
        <div className="mn-collect-modal-mode-big-img-switch-middle-wrap">
          <div
            className="mn-collect-modal-mode-big-img-switch-middle"
            style={{ minWidth: '340px', width: data.length * imageWidth, transform: `translateX(${imgLeft}px)` }}
          >
            {data.map((item, index) => (
              <ImgCheckbox
                key={item}
                item={item}
                index={index}
                value={selected}
                imgIndex={imgIndex}
                onChange={_onChange}
                onSelect={onSelect}
              />
            ))}
          </div>
        </div>
        <div
          style={{ marginLeft: '6px' }}
          className={classNames('mn-collect-modal-mode-big-img-switch-btn', {
            disabled: !(data.length > 5 && imgLeft > -(data.length - 5) * imageWidth),
          })}
          onClick={() => {
            if (data.length > 5) {
              if (imgLeft > -(data.length - 5) * imageWidth) {
                setImgLeft((pre) => pre - imageWidth)
              }
            }
          }}
        >
          <Icon type="m-Vxing_you" />
        </div>
      </div>
      <ImgFooter mode={mode} onMode={onMode} value={selected} setValue={setSelected} onChange={onChange} data={data} />
    </div>
  )
}

const TileImg = ({ mode, onMode, value, onChange, data = [] }) => {
  const [selected, setSelected] = useState([])

  const _onChange = (item, val) => {
    const _index = selected.findIndex((i) => i === val)
    if (_index !== -1) {
      selected.splice(_index, 1)
    } else {
      selected.push(val)
    }
    onChange?.(selected)
    setSelected((pre) => [...pre])
  }

  useEffect(() => {
    setSelected(cloneDeep(value))
  }, [value])

  return (
    <div className="mn-collect-modal-mode-tile-img">
      <div className="mn-collect-modal-mode-tile-img-wrap">
        <div className="mn-collect-modal-mode-tile-img-list">
          {data.map((item, index) => (
            <ImgCheckbox
              key={item}
              item={item}
              value={selected}
              index={index}
              onChange={_onChange}
              width={72}
              height={72}
              imgSelectedMode
            />
          ))}
        </div>
      </div>
      <ImgFooter mode={mode} onMode={onMode} value={selected} setValue={setSelected} data={data} />
    </div>
  )
}

// imgSelected 支持图片选中
const ImgCheckbox = ({ item, value, imgIndex, index, onChange, onSelect, width, height, imgSelectedMode }) => {
  return (
    <div
      className={classNames('mn-collect-modal-img-checkbox', { active: imgIndex === index })}
      onClick={(e) => {
        e.stopPropagation()
        if (imgSelectedMode) {
          onChange?.(item, item)
        }
        onSelect?.(index, item)
      }}
      style={{
        width,
        height,
      }}
    >
      <Checkbox
        checked={value.some((i) => i === item)}
        className="mn-collect-modal-img-checkbox-checkbox"
        onClick={(e) => {
          e.stopPropagation()
        }}
        onChange={() => {
          onChange?.(item, item)
        }}
      />
      <img referrerPolicy="no-referrer" src={picProcess(item)} className="mn-collect-modal-img-checkbox-img" />
    </div>
  )
}

const ImgFooter = ({ mode, onMode, value, setValue, onChange, data }) => {
  const onAll = () => {
    setValue([...data])
    onChange?.([...data])
  }
  const onInvert = () => {
    const _data = data.filter((i) => !value.includes(i))
    onChange?.(_data)
    setValue(_data)
  }
  return (
    <div className="mn-collect-modal-mode-big-img-footer">
      <div className="df-center cursor-pointer" onClick={() => onMode()}>
        <Icon type={`${mode === 1 ? 'm-duotumoshi' : 'm-kapianmoshi'}`} style={{ fontSize: '16px' }} />
        <div style={{ color: 'var(--m-text-1)', marginLeft: '4px' }}>{mode === 1 ? '切换平铺视图' : '切换大图视图'}</div>
      </div>
      <div className="df-center">
        <div style={{ fonSize: '12px' }}>
          <span style={{ color: 'var(--m-text-3)' }}>已选</span>{' '}
          <span style={{ color: 'var(--m-text-1)', marginLeft: '4px' }}>
            {value.length}/{data.length}
          </span>
        </div>
        <Button className="mn-collect-modal-mode-big-img-footer-btn" style={{ marginLeft: '16px' }} onClick={() => onInvert()}>
          反选
        </Button>
        <Button className="mn-collect-modal-mode-big-img-footer-btn" style={{ marginLeft: '8px' }} onClick={() => onAll()}>
          全选
        </Button>
      </div>
    </div>
  )
}
